/**
 * PlatformShell — the frame for platform-admin pages.
 *
 * Platform admins operate above any single org, so they get no sidebar and no
 * scope/topic TopNav — just the Header (logo, theme, user menu) over a single
 * scrolling content area. Their whole world is the three top-tier screens
 * (Group Management, Organizations, and read-only org views reached from
 * there), so a scoped navigation menu would be empty noise.
 *
 * Deliberately parallel to AppShell so both share the same Header, scroll
 * behaviour, and Footer — only the navigation chrome differs.
 */
import styles from "./PlatformShell.module.scss";
import { Header } from "../chrome/Header";
import { Footer } from "../chrome/Footer";

interface Props {
  title: string;
  /** Right-side header controls (e.g. a "New group" button). */
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export const PlatformShell: React.FC<Props> = ({ title, actions, children }) => (
  <div className={styles.shell}>
    {/* Platform admins have no per-org alerts, so no bell. */}
    <Header title={title} actions={actions} showBell={false} />
    <main className={styles.content}>{children}</main>
    <Footer />
  </div>
);
